import { useState, useEffect } from "react";
import { GitHub, LinkedIn } from "@mui/icons-material";

function About()
{
    const [li, setLi] = useState(false);
    const [git, setGit] = useState(false);

    // "Hello" sound
    let sound = new Audio("sounds/hello.mp3");

    function li_hover()
    {
        setLi(true);

        setTimeout(() =>
        {
            setLi(false);
        }, 1000);
    }

    function git_hover()
    {
        setGit(true);

        setTimeout(() =>
        {
            setGit(false);
        }, 1000);
    }

    // hover effect
    useEffect(() =>
    {
        document.querySelectorAll(".stack-holder").forEach((divider) =>
        {
            divider.addEventListener("mouseenter", handleMouseEnter);
        });

        function handleMouseEnter(e)
        {
            const ele = e.target;

            ele.querySelector("p").classList.remove("hidden");

            document.querySelector(".default").classList.add("hidden");
        }

        document.querySelectorAll(".stack-holder").forEach((divider) =>
        {
            divider.addEventListener("mouseleave", handleMouseLeave);
        });

        function handleMouseLeave(e)
        {
            const ele = e.target;

            ele.querySelector("p").classList.add("hidden");

            document.querySelector(".default").classList.remove("hidden");
        }

        return () => 
        {
            document.querySelectorAll(".stack-holder").forEach((divider) => 
            {
              divider.removeEventListener("mouseenter", handleMouseEnter);
            });

            document.querySelectorAll(".stack-holder").forEach((divider) =>
            {
                divider.removeEventListener("mouseleave", handleMouseLeave);
            });
        };
    }, [])

    return(
        <div className="about-container animate__animated animate__slideInUp">

            {/* about section */}
            <div className="abt-section">
                <img className="pfp" src="images/pfp.png" alt="John Dimelu"></img>

                <div className="txt-col">
                    <h2 onClick={() => sound.play()}>Hi, I'm John!</h2>

                    <p>
                    Hey there—I’m a frontend-focused developer and passionate creative based in Greenbelt, MD. With over two years of hands-on professional experience, I thrive at the intersection of design and technology, crafting engaging, intuitive web experiences that feel as good as they look. 
                    I have a deep appreciation for the arts, the web, and the subtle details that make digital products memorable. Long before writing production code, I was driven by curiosity and imagination—exploring illustration, storytelling, and music as ways to bring ideas to life. Those creative roots still shape how I approach frontend development today. I see the browser as my canvas and frontend engineering as a craft—where performance, accessibility, and visual polish come together to create meaningful user experiences. I’m now seeking a new opportunity to continue growing my skills, push my creative and technical boundaries, and contribute to a team that values thoughtful, well-crafted interfaces.
                        <br /><br />
                        When I’m not pushing pixels, I’m usually deep into a great video essay, watching an A24 film, or “hiking” up the stairs to the fridge. I’m curious by nature, detail-oriented (borderline clean freak), and competitive enough to keep improving—even when I’m bad at something. Quick facts: jollof makes any day better, “tea” means hot cocoa where I’m from, I love cinema, I fear heights, and I can’t sleep without the AC blasting. 
                        If any of that resonates—or you just want to build something cool—feel free to reach out.
                    </p>

                    <div className="socials">
                        <a href="https://www.linkedin.com/in/john-dimelu/" target="__blank" onMouseOver={li_hover} className={li ? "animate__animated animate__jello" : undefined}>
                            <LinkedIn sx={{fontSize: 40}}  />
                        </a>

                        <a href="https://github.com/Dimelkjohn" target="__blank" onMouseOver={git_hover} className={git ? "animate__animated animate__jello" : undefined}>
                            <GitHub sx={{fontSize: 40}} />
                        </a>
                    </div>
                </div>
            </div>

            {/* stack section */}
            <div className="stack-section">
                <div className="abstract-stack">
                    <div className="stack-holder">
                        <h3 className="m-stack">M</h3>

                        <p className="stack m hidden">(mongo)</p>
                    </div>

                    <div className="stack-holder">
                        <h3 className="e-stack">E</h3>

                        <p className="stack e hidden">(express)</p>
                    </div>

                    <div className="stack-holder">
                        <h3 className="r-stack">R</h3>

                        <p className="stack r hidden">(react)</p>
                    </div>

                    <div className="stack-holder">
                        <h3 className="n-stack">N</h3>

                        <p className="stack n hidden">(node)</p>
                        <p className="stack s default">(stack)</p>
                    </div>
                </div>

                <p className="ab-p">
                I gravitate toward the MERN stack for its flexibility and how well it supports frontend-driven development. React is where I do my best work—its component-based architecture allows me to design dynamic, interactive interfaces while keeping code clean, scalable, and maintainable.
                My frontend decisions are strengthened by a solid understanding of the backend. I’m comfortable working with Node.js and Express to build efficient APIs, and MongoDB to support scalable, well-structured data. This full-stack awareness helps me create interfaces that are not only visually polished, but also performant and thoughtfully integrated.
                While MERN is a stack I enjoy, I’m always open to adopting new frameworks and tools in pursuit of a bold vision and exceptional user experiences.
                </p>
            </div>
        </div>
    );
}

export default About;